import URL from "../actions/url";

const setAuthToken = token => {
  if(token) {
    return URL.defaults.headers.common['x-auth-token'] = token;
  } else {
    delete URL.defaults.headers.common['x-auth-token'];
  }
}

export default setAuthToken;